import React from 'react';
import { Translation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import QRCode from 'qrcode.react';
import { PREFIX_FRONT_URL } from '../consts';
import AppStore from '../assets/imgs/appStore.png';
import GooglePlay from '../assets/imgs/GooglePlay.png';

function ReferralWithoutLoginComponent() {
  const history = useHistory();
  const query = new URLSearchParams(history.location.search);
  const pubkey = query.get('p') || undefined;
  if (!!pubkey) {
    localStorage.setItem('p', pubkey);
  }

  return (
    <Translation>
      {(t) => (
        <div className="wrap-referral">
          <div className="wrap-body">
            <div className="flr">
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
              >
                <span
                  className="bold fz-14 mt-small mb-small"
                  style={{
                    letterSpacing: 1.4,
                  }}
                >
                  {t('referral.withoutlogin.download')}
                </span>

                <QRCode
                  value="https://crypto.mobilelab.vn/v1/cryptotrading/views/download?aHR0cHM6Ly9jcnlwdG8ubW9iaWxlbGFiLnZuL3YxL2NyeXB0b3RyYWRpbmcvdmlld3MvZG93bmxvYWQ="
                  size={180}
                  style={{ border: 'thick white solid', padding: 10, minHeight: 'auto' }}
                />
                <div className="footer__download">
                  <a href="https://apps.apple.com/app/id1462406645" target="_blank" rel="noreferrer">
                    <img src={AppStore} alt="AppPlay" className="footer__download-img" />
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.trustkeysnetwork" target="_blank" rel="noreferrer">
                    <img src={GooglePlay} alt="GooglePlay" className="footer__download-google" />
                  </a>
                </div>
              </div>
            </div>

            <div className="invite">
              <div className="invite-header">
                <div className="title">
                  {t('referral.withoutlogin.invite.title')}
                </div>
              </div>
              <div className="invite-body">
                {t('referral.withoutlogin.invite.des')}
              </div>
              {window.$isAuthenticated ? (
                <div className="invite-footer d-flex pt-small">
                  <a className="btn-guide" href="#" onClick={() => history.push(`${PREFIX_FRONT_URL}/${window.c.routes.USER_COMMISSION_HISTORY}`)}>
                    <div className="text-normal text-white">
                      {t('referral.withoutlogin.button')}
                    </div>
                  </a>
                  <div className="btn-guide-blur" />
                </div>
              ) : null}
            </div>

            <div className="guide">
              <div className="guide-header">
                <div className="title">
                  {t('referral.withoutlogin.work.title')}
                </div>
              </div>
              <div className="guide-body">
                <div className="block">
                  <div className="block-header">
                    <div className="block-icon">
                      <i className="icon-code" />
                    </div>
                    <div className="block-title">
                      {t('referral.withoutlogin.work.col_1.title')}
                    </div>
                  </div>
                  <div className="block-content">
                    {t('referral.withoutlogin.work.col_1.des')}
                  </div>
                </div>

                <div className="block">
                  <div className="block-header">
                    <div className="block-icon">
                      <i className="icon-alert" />
                    </div>
                    <div className="block-title">
                      {t('referral.withoutlogin.work.col_2.title')}
                    </div>
                  </div>
                  <div className="block-content">
                    {t('referral.withoutlogin.work.col_2.des')}
                  </div>
                </div>

                <div className="block">
                  <div className="block-header">
                    <div className="block-icon">
                      <i className="icon-earning" />
                    </div>
                    <div className="block-title">
                      {t('referral.withoutlogin.work.col_3.title')}
                    </div>
                  </div>
                  <div className="block-content">
                    {t('referral.withoutlogin.work.col_3.des')}
                  </div>
                </div>

                <div className="block">
                  <div className="block-header">
                    <div className="block-icon">
                      <i className="icon-global" />
                    </div>
                    <div className="block-title">
                      {t('referral.withoutlogin.work.col_4.title')}
                    </div>
                  </div>
                  <div className="block-content">
                    {t('referral.withoutlogin.work.col_4.des')}
                  </div>
                </div>
              </div>
            </div>

            <div className="program">
              <div className="program-header">
                <div className="title">
                  {t('referral.withoutlogin.details.title')}
                </div>
              </div>
              <div className="program-body">
                <div className="order-list">
                  <ol start={1}>
                    <li>
                      {t('referral.withoutlogin.details.text_1')}
                    </li>
                    <li>
                      {t('referral.withoutlogin.details.text_2')}
                    </li>
                    <li>
                      {t('referral.withoutlogin.details.text_3')}
                    </li>
                    <li>
                      {t('referral.withoutlogin.details.text_4')}
                    </li>
                    <li>
                      {t('referral.withoutlogin.details.text_5')}
                    </li>
                    <li>
                      {t('referral.withoutlogin.details.text_6')}
                    </li>
                    <li>
                      {t('referral.withoutlogin.details.text_7')}
                    </li>
                    <li>
                      {t('referral.withoutlogin.details.text_8')}
                    </li>
                    <li>
                      {t('referral.withoutlogin.details.text_9')}
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}

export default ReferralWithoutLoginComponent;
